import { needsPlanDetails } from '../resume/earlier-answers';
import { useSignupFlowStore } from '../stores/signup-flow-store';
import type { SignupStepId } from '../steps';
import { useActiveSponsorQuery } from './useActiveSignupSponsor';
import { useSignupNavigation } from './useSignupNavigation';

/**
 * The sponsor whose health-plan switch decides whether `step` must send the
 * member back for their plan details, or null when it cannot owe them: the
 * flow holds them, the step is not between the plan details step and the
 * profile save, or a link with no employer has no pick yet.
 */
export function usePlanDetailsSponsor(
  step: SignupStepId,
): { clientId?: string; subClientId?: string } | null {
  const { path } = useSignupNavigation();
  const planDetails = useSignupFlowStore((state) => state.planDetails);
  const sponsor = useActiveSponsorQuery();
  const named = sponsor.clientId !== undefined || sponsor.subClientId !== undefined;
  return named && planDetails === null && needsPlanDetails(step, path) ? sponsor : null;
}
